import { render, staticRenderFns } from "./TargetV2.vue?vue&type=template&id=5445a274&scoped=true&lang=pug&"
import script from "./TargetV2.vue?vue&type=script&lang=js&"
export * from "./TargetV2.vue?vue&type=script&lang=js&"
import style0 from "./TargetV2.vue?vue&type=style&index=0&id=5445a274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5445a274",
  null
  
)

export default component.exports